import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/icon/iconfont.css";
// 懒加载组件==================================
import {
  Lazyload
} from "vant";
Vue.use(Lazyload);
// element组件库===============================
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/elm.css";
// Vant组件库==================================
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/css/vant.css";
import {
  Toast
} from 'vant';
import {
  Tab,
  Tabs
} from 'vant';
import {
  Stepper
} from 'vant';

// css动画库==================================
import animated from 'animate.css'

// sku组件====================================
import {
  Sku
} from 'vant';
import {
  Popup
} from 'vant';
// 注册组件====================================
Vue.use(Stepper);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Toast);
Vue.use(Sku);
Vue.use(Popup);
Vue.use(animated)
Vue.use(Vant);
Vue.use(ElementUI);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");